define('fukit/templates',['handlebars'], function(Handlebars) {

this["Handlebars"] = this["Handlebars"] || {};
this["Handlebars"]["FuKit"] = this["Handlebars"]["FuKit"] || {};

this["Handlebars"]["FuKit"]["app.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div id=\"app-a11y-announcements\"></div>\n<div style=\"height: 100%; width: 100%; position: relative;\" class=\"pusher\">\n  <div id=\"app-header\"></div>\n  <div id=\"app-tasklist\"></div>\n  <div id=\"app-content-container\">\n    <div id=\"app-notifications\"></div>\n    <div id=\"app-content\" role=\"main\" aria-label=\"main content\"></div>\n    <div id=\"app-overlay\"></div>\n    <div id=\"app-dimmer-container\"></div>\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["FuKit"]["image"] = Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams) {
    var stack1;

  return "<img\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.attributes : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 2, blockParams),"inverse":this.noop,"data":data,"blockParams":blockParams})) != null ? stack1 : "")
    + ">\n";
},"2":function(depth0,helpers,partials,data,blockParams) {
    var alias1=this.lambda, alias2=this.escapeExpression;

  return "  "
    + alias2(alias1(blockParams[0][1], depth0))
    + "=\""
    + alias2(alias1(blockParams[0][0], depth0))
    + "\"\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.svgData : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return this.escapeExpression(((helper = (helper = helpers.svgData || (depth0 != null ? depth0.svgData : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"svgData","hash":{},"data":data}) : helper)))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.attributes : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams),"inverse":this.program(4, data, 0, blockParams),"data":data,"blockParams":blockParams})) != null ? stack1 : "");
},"useData":true,"useBlockParams":true});

this["Handlebars"]["FuKit"]["label.component.view"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "for=\""
    + this.escapeExpression(((helper = (helper = helpers.forElementId || (depth0 != null ? depth0.forElementId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"forElementId","hash":{},"data":data}) : helper)))
    + "\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<label "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.forElementId : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <ui name=\"labelView\" />\n</label>\n<ui name=\"contentView\" />\n<ui name=\"errorView\" />\n";
},"useData":true});

this["Handlebars"]["FuKit"]["three.column.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"pageHeaderView\" />\n<div class=\"ui grid\">\n  <div class=\"three wide column\">\n    <ui name=\"leftColumnView\" />\n  </div>\n  <div class=\"ten wide column\">\n    <ui name=\"contentColumnView\" />\n  </div>\n  <div class=\"three wide column\">\n    <ui name=\"rightColumnView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["FuKit"]["two.column.left.rail.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"pageHeaderView\" />\n<div class=\"ui grid\">\n  <div class=\"three wide column\">\n    <ui name=\"railColumnView\" />\n  </div>\n  <div class=\"thirteen wide column\">\n    <ui name=\"contentColumnView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["FuKit"]["two.column.right.rail.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"pageHeaderView\" />\n<div class=\"ui grid\">\n  <div class=\"thirteen wide column\">\n    <ui name=\"contentColumnView\" />\n  </div>\n  <div class=\"three wide column\">\n    <ui name=\"railColumnView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["FuKit"]["header.container"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"appHeaderView\"/>\n<ui name=\"headerNavView\"/>\n";
},"useData":true});

this["Handlebars"]["FuKit"]["page.header"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui grid\">\n  <div class=\"sixteen wide tablet eight wide computer column\">\n    <div>\n      <ui name=\"headerView\" />\n    </div>\n    <ui name=\"breadcrumbView\" />\n  </div>\n  <div class=\"sixteen wide tablet eight wide computer right desktop aligned column\">\n    <ui name=\"actionsView\" /><ui name=\"actionsFromCollectionView\" />\n  </div>\n</div>\n\n<ui name=\"errorMessageView\" />\n\n<ui name=\"notificationView\" />\n";
},"useData":true});

this["Handlebars"]["FuKit"]["pagination"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui pagination grid stackable\">\n  <div class=\"seven wide column\">\n    <ui name=\"paginationDropdownView\" />\n  </div>\n  <div class=\"center aligned two wide column desktop only\">\n    <ui name=\"paginationCountView\" />\n  </div>\n  <div class=\"right aligned seven wide column desktop only\">\n    <ui name=\"paginationMenuView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["FuKit"]["simple.pagination"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui pagination grid stackable\">\n  <div class=\"six wide column\">\n    <ui name=\"previousButtonView\" />\n  </div>\n  <div class=\"center aligned four wide column\">\n    <ui name=\"paginationCountView\" />\n  </div>\n  <div class=\"right aligned six wide column\">\n    <ui name=\"nextButtonView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["FuKit"]["list.page"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<div class=\"ui tertiary segment top attached\">\n  <ui name=\"tokenInputView\" />\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<ui name=\"pageHeaderView\" />\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.useVisualSearch : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<ui name=\"tableView\" />\n";
},"useData":true});

return this["Handlebars"];

});
